import { b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';
import { observer } from 'mobx-react-lite';
import '../../../contexts/TranslationContext.js';
import '../../../contexts/StoreContext.js';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import { BetResponseCode } from '../../../core/enums/ResponseCodes.js';
import { numPadTypes } from '../../../core/enums/BogLineGameConfig.js';
import { isMobile } from '../../../core/helpers/isMobile.js';
import { a1 as betDataStore, y as freeBetStore, _ as gameConfigStore } from '../../../../environmentBuilder-3507f66e.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import { inputValidationStore } from '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import { useInputValueChangingFunctions } from '../../../hooks/useInputValueChangingFunctions.js';
import { InputTypesForChanging, AdditionalInputValueChangingButtons } from '../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';

var BetAmount = observer(function (_a) {
    var sectionIndex = _a.sectionIndex, handleOpenNumPad = _a.handleOpenNumPad;
    var dividerOrMultiplayer = 2;
    var setBetAmount = betDataStore.setBetAmount, setIsAmountChangeCustom = betDataStore.setIsAmountChangeCustom, betsSectionsData = betDataStore.betsSectionsData;
    var activeFreeBet = freeBetStore.activeFreeBet;
    var _b = gameConfigStore.limits, limits = _b === void 0 ? {} : _b;
    var _c = betsSectionsData[sectionIndex], index = _c.index, betAmount = _c.betAmount, isAmountChangeCustom = _c.isAmountChangeCustom;
    // const { isAmountChangeCustom } = betsSectionsData[index];
    var handleChangeInputValue = useInputValueChangingFunctions({
        changingValue: +betAmount,
        changingValueCallback: setBetAmount,
        additionalInputInfo: {
            inputType: InputTypesForChanging.BetInput,
        },
    }).handleChangeInputValue;
    var params = {
        storeValue: betAmount,
        minValue: limits.minBet,
        maxValue: limits.maxBet,
        incDec: limits.minBet,
    };
    var onBlur = function (e) {
        var _a;
        inputValidationStore.setDefaultValue((_a = e.target) === null || _a === void 0 ? void 0 : _a.value.trim(), setBetAmount, params, index, {
            minOdd: BetResponseCode.InValidMinBet,
            maxOdd: BetResponseCode.InValidMaxBet,
        });
    };
    return (React.createElement("div", { className: "aviabet-bet-section-input-wrp  ".concat((activeFreeBet === null || activeFreeBet === void 0 ? void 0 : activeFreeBet.id) ? 'disabled' : '') },
        React.createElement("div", { className: 'aviabet-bet-section-inp-icon ', onClick: function () { return handleChangeInputValue(AdditionalInputValueChangingButtons.minus, dividerOrMultiplayer, index); } },
            React.createElement("i", { className: 'ui-lib-avi-minus' })),
        React.createElement("div", { className: 'aviabet-bet-section-input-inner' },
            React.createElement("input", __assign({ className: 'aviabet-bet-section-input', type: 'text', maxLength: 9, value: betAmount || '', inputMode: isMobile() ? 'none' : 'text', readOnly: isMobile(), onPaste: function (e) { return e.preventDefault(); }, onBlur: onBlur, onChange: function (evt) {
                    if (!/^[.,]/.test(evt.target.value) && /^\d*[.,]?\d*$/.test(evt.target.value)) {
                        if (!isAmountChangeCustom) {
                            setIsAmountChangeCustom(true, index);
                        }
                        setBetAmount(evt.target.value.replace(',', '.'), index);
                    }
                } }, (isMobile()
                ? {
                    onClick: function (e) { return handleOpenNumPad(e, numPadTypes.betAmount, index, params); },
                }
                : {})))),
        React.createElement("div", { className: 'aviabet-bet-section-inp-icon', onClick: function () { return handleChangeInputValue(AdditionalInputValueChangingButtons.plus, dividerOrMultiplayer, index); } },
            React.createElement("i", { className: 'ui-lib-avi-plus' }))));
});

export { BetAmount };
